import { logFormData } from 'shared/lib/logFormData';

import type { TLandingFormFields } from 'entities/creditForm';
import { setLandingInfo, sendStepsAnalyticsEvents } from 'entities/creditForm';

import { LandingInfoTexts } from '../LandingInfo.texts';

export const submitLandingForm =
  (actualData: TLandingFormFields): ThunkResult<void> =>
  async (dispatch) => {
    dispatch(setLandingInfo({ data: actualData }));
    logFormData('LandingInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([0, 1], LandingInfoTexts, 'manual'));
  };
